import { Document, Page } from "@react-pdf/renderer";
import { getTenantStore } from "../../../../stores/tenantStore";
import { styles } from "../../ReactPdfStyles";
import PdfHeader from "../PdfHeader";
import ReportingApprovalRecordSection from "../ReportingApprovalRecordSection";
import ReportingProjectDetailSection from "../ReportingProjectDetailSection";
import LessonDetailSection from "./LessonDetailSection";

export const LessonLearnedPDFTemplate = ({
	data,
}: {
	data: Record<string, any>;
}) => {
	const tenantList = getTenantStore().getTenantList();
	const tenant = tenantList.find(
		(tenant: any) => tenant.value === data.operator
	);
	const reportLogoUrl = tenant?.report_logo ?? tenant?.logo;

	return (
		<Document>
			<Page size="A4" style={styles.document} orientation="portrait">
				<PdfHeader
					reportTitle="LESSON LEARNED"
					data={{
						internal_report: data.internal_report,
						report_number: data.report_number,
						title: data.title,
					}}
					reportLogo={reportLogoUrl}
				/>

				{/* <ProjectDetailSection
					operator={data.operator ?? "N/A"}
					operation_name={data.operation_name ?? "N/A"}
					project={data.project_name ?? "N/A"}
					project_code={data.project_code ?? "N/A"}
					rig={data.rig}
					country={data.country ?? "N/A"}
					project_area={data.project_area ?? "N/A"}
					phase={data.phase_name ?? "N/A"}
					well={data.well_name ?? "N/A"}
					task={data.task_name ?? "N/A"}
				/> */}
				<ReportingProjectDetailSection data={data} />

				<LessonDetailSection
					discipline={data.discipline_name ?? data.discipline ?? "N/A"}
					lesson_learned_type={data.lesson_learned_type ?? "N/A"}
					origin={data.origin ?? "N/A"}
					lesson_learned_classification={
						data.lesson_learned_classification ?? "N/A"
					}
					section={data.section}
					what_planned={data.what_planned ?? "N/A"}
					what_happened={data.what_happened ?? "N/A"}
					what_learned={data.what_learned ?? "N/A"}
					what_actions_required={data.what_actions_required ?? "N/A"}
					what_was_done={data.what_was_done ?? "N/A"}
				/>
				<ReportingApprovalRecordSection data={data} />
			</Page>
		</Document>
	);
};
